export const API_ENDPOINT_URL = process.env.REACT_APP_API_ENDPOINT_URL;
